module.exports = __webpack_public_path__ + "media/images/illustration_16-ba910fa4be98d8410bed13b7dce2c47e.png";